"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const utils_1 = require("data/transactions/utils");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const PayeeField_1 = __importDefault(require("components/QuickenControls/PayeeField"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const RegPayeeField = ({ txn, onChange, onFocus, onBlur, editable, forceStatic, autoFocus, inputRef, accountIds, }) => {
    var _a, _b;
    const { classes, theme } = useStyles();
    const payeeShowFillInfoInMenu = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('payeeShowFillInfoInMenu'), react_redux_1.shallowEqual);
    const payeeAutoFillCat = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillCat'), react_redux_1.shallowEqual);
    const payeeAutoFillAmount = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillAmount'), react_redux_1.shallowEqual);
    const payeeAutoFillMemo = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillMemo'), react_redux_1.shallowEqual);
    const payeeAutoFillTags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('payeeAutoFillTags'), react_redux_1.shallowEqual);
    const payeeObj = (0, react_1.useMemo)(() => ({ payee: txn.payee || '' }), [txn.payee]);
    let menuFields = 'payee';
    if (payeeShowFillInfoInMenu) {
        if (payeeAutoFillCat) {
            menuFields += 'category';
        }
        if (Number(txn.amount) === 0 && payeeAutoFillAmount) {
            menuFields += 'amount';
        }
        if (!txn.memo && payeeAutoFillMemo) {
            menuFields += 'memo';
        }
        if (!(0, utils_1.txnHasTags)(txn) && payeeAutoFillTags) {
            menuFields += 'tags';
        }
    }
    return editable ? (<PayeeField_1.default 
    // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
    disableUnderline={(_a = theme.mixins) === null || _a === void 0 ? void 0 : _a.register.noUnderline} accountIds={accountIds} menuShowFields={menuFields} editable 
    // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
    fontSize={(_b = theme.mixins) === null || _b === void 0 ? void 0 : _b.register.fontSize.default} onFocus={onFocus} onBlur={onBlur} onChange={onChange} autoFocus={autoFocus} value={payeeObj} inputRef={inputRef} textFieldVariant="standard" width="100%"/>) : (
    // @ts-expect-error: missing props
    <QTip_1.default wrapOnly title={txn.payee} wrapId={`${txn.id}-payee`}>
      <QTypography_1.default clickable={!forceStatic ? 'true' : null} thinFont className={classes.regItemCore}>
        {txn.payee}
      </QTypography_1.default>
    </QTip_1.default>);
};
exports.default = (RegPayeeField);
